import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33965f21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center pt-8 px-3" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "mt-4 mb-3",
  "data-test": "error-screen-header"
}

import errorImgSrc from '@grantstreet/govhub-vue/src/assets/error-page-illustration.svg'

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadFailure',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("img", { src: _unref(errorImgSrc) }, null, 8, _hoisted_2),
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(`error.loadFailure.title`)), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t(`error.loadFailure.desc`)), 1)
  ]))
}
}

})